import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Football(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 8.243V5.29L8.632 3.651a9.031 9.031 0 00-4.1 3.323l1.32 3.078 2.526.42 3.122-2.23zm-3.406 3.196l-2.45-.408-2.568 2.14a8.941 8.941 0 001.142 3.352l3.52.44 1.227-2.043-.87-3.48zm1.69 4.061L8.54 17.571l.872 3.051c.82.246 1.688.378 2.588.378.9 0 1.768-.132 2.588-.378l.872-3.05-1.243-2.072H9.783zm5.251-.58L16.283 17h3.201a8.948 8.948 0 001.44-3.829l-2.568-2.14-2.45.408-.87 3.481zm.587-4.447l2.511-.419 1.218-3.248a9.03 9.03 0 00-3.983-3.155L12.5 5.291v2.952l3.122 2.23zM12 4.424L9.927 3.24A9.026 9.026 0 0112 3c.713 0 1.407.083 2.073.24L12 4.424zm8.466 2.25A9.993 9.993 0 0012 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10a9.953 9.953 0 00-1.534-5.325zm-.455 1.22l-.918 2.45L21 11.931a8.96 8.96 0 00-.989-4.038zm-5.079 3.315L12 9.114 9.068 11.21 9.89 14.5h4.22l.822-3.291zM18.708 18h-2.33l-.624 2.182A9.028 9.028 0 0018.708 18zM8.246 20.182l-.636-2.227-2.635-.33a9.034 9.034 0 003.271 2.557zM3 11.932l1.894-1.578-.986-2.299A8.962 8.962 0 003 11.932z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Football);
export default ForwardRef;